var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_calendar_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M4.5 18c-.41 0-.77-.15-1.06-.45-.3-.3-.44-.65-.44-1.05v-11c0-.4.15-.75.44-1.05.3-.3.65-.45 1.06-.45H6V2.75c0-.21.07-.4.21-.53A.72.72 0 0 1 6.75 2c.2 0 .39.07.53.22.15.14.22.32.22.53V4h5V2.75c0-.21.07-.4.21-.53a.72.72 0 0 1 .54-.22c.2 0 .39.07.53.22.15.14.22.32.22.53V4h1.5c.41 0 .77.15 1.06.45.3.3.44.65.44 1.05v11c0 .4-.15.75-.44 1.05-.3.3-.65.45-1.06.45h-11Zm0-1.5h11V9h-11v7.5Zm0-9h11v-2h-11v2Z"
  }))));
};
export default SvgIconCalendar;